import { render, staticRenderFns } from "./relatedVideo.vue?vue&type=template&id=1eb5c8c0&"
import script from "./relatedVideo.vue?vue&type=script&lang=js&"
export * from "./relatedVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports